import { moscowTime, parseServerDate } from './moscowTime';
import { PassStatus } from './passes';

/** GET /v1/passes/{id}/events item (v1 PassesEventResource). */
export interface PassEvent {
  passId: number;
  happenedAt: string;
  /** `[]` when nobody was logged in (cron, system). */
  initiatedBy: { id: number; name: string; type: 'tenant' | 'user' | string } | [];
  /** 1 created, 2 changed, 4 status changed. */
  type: number;
  eventData: Record<string, unknown>;
}

function statusText(status: number, prev: number | undefined): string {
  if (status === PassStatus.Inside) return 'Гость въехал';
  if (status === PassStatus.Expected && prev === PassStatus.Inside) return 'Гость выехал';
  if (status === PassStatus.Expected && prev === PassStatus.WaitingGuest) return 'Гость заполнил данные';
  if (status === PassStatus.Expected && prev === PassStatus.Pending) return 'УК согласовала пропуск';
  if (status === PassStatus.Closed) return 'Пропуск закрыт';
  if (status === PassStatus.InviteCanceled) return 'Приглашение отменено';
  if (status === PassStatus.Expired) return 'Срок истёк';
  return 'Статус изменён';
}

export function describeEvent(e: PassEvent): { time: string; text: string; who: string } {
  const at = parseServerDate(e.happenedAt);
  const status = typeof e.eventData.status === 'number' ? e.eventData.status : undefined;
  const prev = typeof e.eventData.prevStatus === 'number' ? e.eventData.prevStatus : undefined;
  const text =
    e.type === 1 ? (status === PassStatus.WaitingGuest ? 'Приглашение создано' : 'Пропуск оформлен')
    : e.type === 4 && status !== undefined ? statusText(status, prev)
    : 'Пропуск изменён';
  const by = Array.isArray(e.initiatedBy) ? null : e.initiatedBy;
  // Only the resident's own actions are signed: staff names are whatever the admin typed («Вася тест»), #4216.
  const who = by?.type === 'tenant' ? 'Вы' : '';
  return { time: at ? moscowTime(at) : '', text, who };
}

/** The guest has been inside at least once: the server then ignores guest/plate/type changes (spec §6.6). */
export const wasUsed = (events: readonly PassEvent[]) => events.some((e) => e.eventData.status === PassStatus.Inside);
